import { getProductCategories } from "@hardware/Services/CustomProductService";
import { setGA4Event } from "@hardware/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Data/Carts/Handlers/AddCartLines";

addToChainAfter(chain, ExecuteOnSuccessCallback, async props => {
    const result = await getProductCategories({
        productIds:
            props.apiParameter.cartLineCollection.cartLines
                ?.filter(line => line.productId !== null && line.productId !== undefined)
                .map(line => line.productId!) || [], // Ensure productIds is always an array
                type: "product",
    });

    if (result.successful) {
        const { categories, brandName: brand, categoriesIds } = result.result.productProperties[0];
        const categoriesToArr = Object.values(categoriesIds);
        const pageCategoryId = categoriesToArr[categoriesToArr.length - 1] || "";
        const productCategories = result.result.productProperties;
        const qtysOrdered = props.apiParameter.cartLineCollection.cartLines;

        // Add null check for props.apiResult.cartLines
        if (props.apiResult.cartLines) {
            setGA4Event("add_to_cart", props.apiResult.cartLines, {
                categories,
                brand,
                pageCategoryId,
                productCategories,
                qtysOrdered,
            });
        }
    }
});
